import actions from "actions/actionTypes";

const initialState = {
  message: null
};

/**
 * Message Reducer
 * @param {Object} state
 * @param {Object} action
 * @param {String} action.type
 * @param {Object} action.payload
 * @param {String} action.payload.text
 * @param {String} action.payload.type Examples: "success", "error"
 */
const messageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.DISPLAY_MESSAGE:
      return {
        ...state,
        message: payload
      };
    case actions.RESET_MESSAGE:
      return {
        ...state,
        message: null
      };
    default:
      return state;
  }
};

export default messageReducer;
